import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { DriversLockedContent } from "./DriversLockedContent";
import { DriversLockedActions } from "./DriversLockedActions";
import { driversLockedErrorSelector } from "../../../reducers/ownApp/selectors";
import { setDriversLockedError } from "../../../reducers/ownApp";
import { forceUnlockDrivers } from "../../../reducers/matrixProfile/thunkActions";

export const DriversLockedModal = memo(() => {
  const dispatch = useDispatch();
  const error = useSelector(driversLockedErrorSelector);

  const onClose = () => dispatch(setDriversLockedError(null));
  const onForceUnlock = () => {
    dispatch(forceUnlockDrivers());
    dispatch(setDriversLockedError(null));
  };

  return (
    <Modal
      open={!!error}
      onClose={onClose}
      title={"Drivers Locked Error"}
      content={<DriversLockedContent error={error} />}
      actions={
        <DriversLockedActions
          onCancel={onClose}
          onForceUnlock={onForceUnlock}
        />
      }
      maxWidth={"sm"}
    />
  );
});
